import { relaunchApi } from '@/logic/relaunchApi'

export default {
  getCommunities: () => relaunchApi.get('/communities'),
  getCommunityUsers: (communityId, params = {}) => relaunchApi.get(`/communities/${communityId}/users`, params),
  getCommunityPosts: (communityId, params = {}) => relaunchApi.get(`/communities/${communityId}/posts`, params),
  getCommunityPost: (postId) => relaunchApi.getWithErrorDetails(`/communities/posts/${postId}`),
  deleteCommunityPost: (postId) => relaunchApi.delete(`/communities/posts/${postId}`, {}),
  addCommunityPostViewEvent: (postId) => relaunchApi.post(`/communities/posts/${postId}/add-view-event`),
}
